import { createStore, applyMiddleware } from 'redux'
import creteSagaMiddleware from 'redux-saga'
import reducer from './reducers'
import rootSaga from './saga'

const sagaMiddleware = creteSagaMiddleware()

export default createStore(reducer, applyMiddleware(sagaMiddleware))
sagaMiddleware.run(rootSaga)